import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { MainService, IResponse } from 'src/app/services/main.service';
import { ElectronService } from 'ngx-electron';
import { ChildProcessService } from 'ngx-childprocess';
import { SignalrService } from 'src/app/services/signalr.service';
@Injectable({
  providedIn: 'root'
})
export class PrintService {

  constructor(private http: HttpClient, private ms: MainService, private _electronService: ElectronService,
    private _childProcessService: ChildProcessService, private srs: SignalrService) { }
  private Save_Print(body) {
    return this.http
      .post(this.ms.baseUrl + '/services/api/rest/v1/Sent_TextPrint', body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
  SendToPrinter(data, type) {
    const os = document.getElementById('os').innerText;
    const d = {
      PrintData: JSON.stringify(data)
    };
    this.Save_Print(d).subscribe(res => {
      if (res.Success) {
        const url = this.ms.baseUrl + '/' + res.data;
        console.log(url);
        if (this._electronService.isElectronApp) {
          const path = this._electronService.remote.app.getAppPath().replace('app.asar', '') + '/iPOS_Print.exe ' + type + ',';
          const f_path = path + url;
          console.log(f_path);
          // alert(path);
          this._childProcessService.childProcess.exec(f_path, null, (data: any) => { console.log(data); });

        } else if (os === 'Windows' && !this.ms.CommonSetting.SocketAllow) {
          const abc = document.getElementById('ipospos');
          abc.setAttribute('href', 'ipospos:' + type + ',' + url);
          abc.click();
        } else {
          let print = '';
          const set = this.ms.getSettings().PrinterName;
          if (set.trim() != '') {
            print = ',' + set;
          }
          this.srs.sendToMultiplePrint({ LocationId: 1, Url: type + ',' + url + print, PrinterName: '', PrinterIp: '' });
        }
      }
    });
  }
  closeApplication() {
    if (this._electronService.isElectronApp) {
      this._electronService.remote.app.quit();
      // this._electronService.screen.
    }
  }
  getUniqueId(): string {
    let uid = '';
    if (this._electronService.isElectronApp) {
      uid = this._electronService.remote.require('os').hostname();
    } else {
      if (localStorage.getItem('RetailPOS_UniqueId')) {
        uid = localStorage.getItem('RetailPOS_UniqueId');
      } else {
        uid = document.getElementById('sysId').innerText;
      }

    }
    return uid;
  }
}
